import { useEffect, useMemo, useState } from 'react';

import type { DateRange } from '@/entities/query/types';
import { getDefaultChartPeriod } from '../helpers/get-default-chart-period';
import type { ChartPeriod } from '../types';

export function useSelectedPeriod({ dateRange }: { dateRange: DateRange }) {
  const [selectedPeriod, setSelectedPeriod] = useState<ChartPeriod | null>(null);

  const defaultPeriod = useMemo(
    () => getDefaultChartPeriod(dateRange.startDate, dateRange.endDate),
    [dateRange.startDate, dateRange.endDate],
  );

  useEffect(() => {
    setSelectedPeriod(null);
  }, [dateRange.startDate, dateRange.endDate]);

  const currentPeriod = useMemo(() => {
    return selectedPeriod ?? defaultPeriod;
  }, [selectedPeriod, defaultPeriod]);

  return [currentPeriod, setSelectedPeriod] as const;
}
